
export const UserForm = {
    structure: {
        status: true,
        zones: []
    },
    errors: {},
    blocks: [
        {
            col: [12],
            card: [
                {
                    col: [6, 12, 3],
                    name: 'fullName',
                    label: 'Nombre'
                },
                {
                    col: [6, 12, 3],
                    name: 'login',
                    label: 'Login'
                },
                {
                    col: [6, 12, 3],
                    type: 'email',
                    name: 'email',
                    label: 'E-mail'
                },
                {
                    col: [6, 12, 3],
                    name: 'phone',
                    label: 'Teléfono'
                },
                {
                    col: [12, 12, 12],
                    type: 'password',
                    name: 'password',
                    label: 'Contraseña'
                },
                {
                    col: [2, 6, 2],
                    name: 'roleId',
                    label: 'Rol',
                    endPoint: 'role',
                    type: 'select'
                },
                {
                    col: [2, 6, 2],
                    name: 'status',
                    label: 'Estado',
                    endPoint: 'enumeration',
                    type: 'select',
                    isEnum: true
                },
                {
                    col: [2, 12, 2],
                    name: 'id',
                    label: 'Zona',
                    endPoint: 'zone',
                    type: 'select',
                    isMulti: true,
                    collection: ['zones']
                }
            ]
        }
    ]
}